import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { MarketModel } from "../models/market.model";
import { DataService } from "../services/data/data.service";
import { SaleService } from "../services/sale/sale.service";

@Injectable({
  providedIn: "root"
})
export class MarketLightResolverService implements Resolve<MarketModel> {
  constructor(private dataService: DataService, private saleService:SaleService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MarketModel> | Observable<never> {
    const id = route.paramMap.get("marketId");
    const status = route.paramMap.get("status") || "open";
    if (id == undefined) {
      const date = new Date();
      date.setDate(date.getDate()+7);
      const dateIso = date.toISOString();
      const newItem = <MarketModel>{
        details: {
          datesPlaces:[{
            date:dateIso,
            geocoding:{
              address:{}
            },
            moment: 'morning',
            fromTimeHour:'08:00',
            toTimeHour:'12:00',
          }],
          currency: "EUR",
          format: "group",
          recurrence: "weekly",
          ordersVisible: true,
          singleOrder: true,
          allowPaymentCollection: false,
          deliveryType:'market',
          deliveryCost:0,
          frequency:1,
          opening:6,
          closing:1
        },
        status: "new",
        applicationStatus:"open",
        producers: {},
        tournees: {},
        finances: {
          producerCount: 0
        },
        notifications:{
          config:['producer','sale','place'],
        }
      };
      return of(newItem);
    } else {
      return this.dataService.getMarketLight(id).pipe(
        take(1),
        mergeMap(item => {
          if (item && Object.keys(item).length > 1) {
            item.details.datesPlaces = this.saleService.getDatesPlaces(item.details);
            return of(item);
          } else {
            return this.dataService.getMarket(id).pipe(
              take(1),
              mergeMap(item => {
                console.log('get market fallback - sale light empty', item);
                if (item && Object.keys(item).length > 1) {
                  item.details.datesPlaces = this.saleService.getDatesPlaces(item.details);
                  return of(item);
                } else {
                  return EMPTY;
                }
              })
            );
          }
        })
      );
    }
  }
}
